import { all, takeLatest, call, put } from "redux-saga/effects";
import { fetchVisitsRoasterAPI, cancelAppointmentEventAPI } from "../../../services/visits-roaster-service";
import { message } from 'antd';
import {
    FETCH_VISITS_ROASTER, FETCH_VISITS_ROASTER_START, FETCH_VISITS_ROASTER_SUCCESS, FETCH_VISITS_ROASTER_ERROR,
    CANCEL_APPOINTMENT_EVENT, CANCEL_APPOINTMENT_EVENT_SUCCESS, CANCEL_APPOINTMENT_EVENT_ERROR, UNDO_VISIT, UNDO_VISIT_ERROR, UNDO_VISIT_SUCCESS
} from "../../actions/receptionist/visitsRoasterAction";
import { undoVisitAPI } from "../../../services/worklist-service";

function* fetchVisitsRoaster({ payload }) {
    try {
        yield put({ type: FETCH_VISITS_ROASTER_START })
        const response = yield call(fetchVisitsRoasterAPI, payload)
        if (response.success) {
            let sortedVisitsRoaster = [...response.data];
            if (sortedVisitsRoaster.length > 0) {
                sortedVisitsRoaster.sort(function (a, b) {
                    return new Date(b.start) - new Date(a.start);
                });
            }
            yield put({ type: FETCH_VISITS_ROASTER_SUCCESS, visitsRoaster: [...sortedVisitsRoaster] });
        } else {
            message.error('Failed to fetch visits!');
            yield put({ type: FETCH_VISITS_ROASTER_ERROR })
        }
    }
    catch (error) {
        message.error('Failed to fetch visits!');
    }
}

function* cancelAppointmentEvent({ payload }) {
    try {
        const response = yield call(cancelAppointmentEventAPI, payload.appointmentId, payload.eventId);
        if (response.success) {
            yield put({ type: CANCEL_APPOINTMENT_EVENT_SUCCESS, visitsRoasterData: { appointmentId: payload.appointmentId, eventId: payload.eventId } })
            message.success('Appointment cancelled successfully!');
        } else {
            yield put({ type: CANCEL_APPOINTMENT_EVENT_ERROR, error: response.error })
            message.error('Failed to cancel appointment!');
        }
    } catch (error) {
        message.error('Failed to cancel appointment!');
        yield put({ type: CANCEL_APPOINTMENT_EVENT_ERROR, error: error })

    }
}


export function* undoVisit({ payload }) {
    try {
        const response = yield call(undoVisitAPI, payload.visitId);
        if (response.success) {
            message.success("Visit undone successfully.");
            yield put({ type: UNDO_VISIT_SUCCESS, visit: payload })
        } else {
            message.error('Failed to undo visit!');
            yield put({ type: UNDO_VISIT_ERROR, receipts: [] })
        }

    } catch (error) {
        message.error(error);
    }
}

function* visitsRoasterWatcher() {
    yield takeLatest(FETCH_VISITS_ROASTER, fetchVisitsRoaster)
    yield takeLatest(CANCEL_APPOINTMENT_EVENT, cancelAppointmentEvent)
    yield takeLatest(UNDO_VISIT, undoVisit)
}

export default function* rootSaga() {
    yield all([visitsRoasterWatcher()])
}